var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3719 10.3618L14.3909 21.4869L16.2413 25.0134L19.6069 22.8845L22.5879 11.7594L17.3719 10.3618ZM16.9685 8.39016C16.4883 8.26152 15.9948 8.54644 15.8662 9.02656L12.5613 21.3607C12.5027 21.5791 12.5286 21.8116 12.6336 22.0118L15.1007 26.7138C15.345 27.1793 15.9345 27.3373 16.3788 27.0563L20.8664 24.2178C21.0575 24.0969 21.1961 23.9085 21.2546 23.6901L24.5595 11.3559C24.6882 10.8758 24.4032 10.3823 23.9231 10.2537L16.9685 8.39016Z",
    fill: "#5F6161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6561 15.2366L16.4401 13.839L16.906 12.1003L22.122 13.498L21.6561 15.2366Z",
    fill: "#5F6161"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGrey);
export default __webpack_public_path__ + "static/media/EditGrey.670cb19cdb1f470947a5860988d3a8f8.svg";
export { ForwardRef as ReactComponent };